const { get, post, putCatalog,remove } = require("api");

export const getCatalogs = (query) => {
  return get(
    `/data/${query.catalogKey}?OrganizationId=${query.OrganizationId}&Country=${query.Country}&City=${query.City}&ProjectType=${query.ProjectType}&LaborType=${query.LaborType}&State=${query.State}`,
    true
  );
};

//API call to get data of version, awps, categories by giving their unique key
export const getDataByEndpoint = (query) => {
  return get(`/data/${query}`, true);
};

export const getExchangeRate = (data) => {
  return get(
    `/rates?from=${data.from}&to=${data.to}&value=${data.value}`,
    true
  );
};

export const getCategories = (query) => {
  let url = `/data/categories`;
  if (query) {
    url = `${url}?$skip=${query.skip}&$limit=${query.limit}&$search=${query.search}&$column=${query.column}`;
  }
  return get(url, true);
};

export const addNewProjectType = (OrganizationId, body) => {
  return post(
    `/data/project_types?OrganizationId=${OrganizationId}&Override=false`,
    body,
    false,
    true
  );
};

export const addNewLaborType = (OrganizationId, body) => {
  return post(
    `/data/labor_types?OrganizationId=${OrganizationId}&Override=false`,
    body,
    false,
    true
  );
};

export const addNewTemplate = (OrganizationId, body) => {
  return post(
    `/data/versions?OrganizationId=${OrganizationId}&Override=false`,
    body,
    false,
    true
  );
};

export const addNewCatalogs = (format, OrganizationId, body) => {
  return post(
    `/data/${format}?OrganizationId=${OrganizationId}&Override=false`,
    body,
    false,
    true
  );
};

export const updateCatalogs = (format, catalog) => {
  return putCatalog(`/data/${format}/${catalog?._id}`, catalog, false, true);
};

export const deleteCatalog = (format, catalog) => {
  return remove(`/data/${format}/${catalog._id}`, catalog, true);
};

// ---------------------------------------------------------------------------
// Estimating database pages (labor, tools, materials, general conditions...).
// The same curlight /data service and the same wire the desktop estimating
// app uses (BidlightApp.Services/Definition/ApiServiceBase.cs):
//   GET    /data/{ep}?OrganizationId=..&Country=..&Version=..
//   POST   /data/{ep}?OrganizationId=..&Override=True|False   body: [rows]
//   PUT    /data/{ep}?OrganizationId=..                       body: [rows with _id]
//   DELETE /data/{ep}/{id}?OrganizationId=..
//
// Every call from these pages names its surface, and CurLight refuses a call
// that names it unless the caller holds estimatingDatabase (owner 2026-10-26,
// curlight routes/estimatingDatabaseGate.js). The desktop app and the
// Estimation app send no surface, so their /data calls are untouched.
export const ESTIMATING_DATABASE_SURFACE = { "X-BidLight-Surface": "estimating-database" };

const databaseQuery = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

export const getDatabaseRows = (endpoint, OrganizationId, filters = {}) => {
  return get(
    `/data/${endpoint}${databaseQuery({ ...filters, OrganizationId })}`,
    true,
    ESTIMATING_DATABASE_SURFACE
  );
};

export const postDatabaseRows = (endpoint, OrganizationId, rows, override = false) => {
  return post(
    `/data/${endpoint}${databaseQuery({
      OrganizationId,
      Override: override ? "True" : "False",
    })}`,
    rows,
    false,
    true,
    ESTIMATING_DATABASE_SURFACE
  );
};

export const putDatabaseRows = (endpoint, OrganizationId, rows) => {
  return putCatalog(
    `/data/${endpoint}${databaseQuery({ OrganizationId })}`,
    rows,
    ESTIMATING_DATABASE_SURFACE
  );
};

export const deleteDatabaseRow = (endpoint, id, OrganizationId) => {
  return remove(
    `/data/${endpoint}/${encodeURIComponent(id)}${databaseQuery({ OrganizationId })}`,
    {},
    true,
    ESTIMATING_DATABASE_SURFACE
  );
};
